import { memo } from 'react';
import '../styles/MediaCard.css';
import config from '../config';
import { launchLocalPlayer } from '../utils/localPlayerLauncher';

function MediaCard({ media }) {
  const placeholder = 'https://tse1-mm.cn.bing.net/th/id/OIP-C.dC6CLNcwmIg1I2fEbinJyQHaE5';

  // 处理媒体对象（兼容多种格式）
  const mediaData = {
    name: media?.name || '未知电影',
    director: media?.director || '未知导演',
    actors: media?.actors || '',
    genres: media?.genres || '',
    year: media?.year || '',
    rating: media?.rating || 0,
    description: media?.description || '',
    views: media?.views || '-',  // 播放量
    duration: media?.duration || '-',  // 时长
    id: media?.id || Math.random(),
    file_name: media?.file_name || '',
    img: media?.img || '',
    url: media?.url || ''
  };

  const mediaUrl = mediaData.url || media?.play_url || media?.media_url || config.testVideoUrl || config.testVideoFallback;
  const mediaImg = mediaData.img || placeholder;

  const openPlayer = () => {
    const launchResult = launchLocalPlayer({
      title: mediaData.name,
      sourceUrl: mediaUrl,
      entryUrl: config.localPlayerEntry,
      storageKey: config.localPlayerStorageKey,
    });

    if (!launchResult.launched) {
      console.warn('[LocalPlayer] launch failed', launchResult);
    }
  };

  return (
    <div className="video-card">
      <div className="thumbnail-container" style={{ position: 'relative' }}>
        <img 
          src={mediaImg}
          onError={(e) => { e.currentTarget.src = placeholder; }}
          className="thumbnail"
          alt={mediaData.name}
          loading="lazy"
          decoding="async"
          style={{ cursor: 'pointer' }}
          onClick={openPlayer}
        />
        {/* 时长标签 */}
        {mediaData.duration && mediaData.duration !== '-' && (
          <span className="duration">{mediaData.duration}</span>
        )}
        <button 
          className="play-button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            openPlayer();
          }}
        >
          ▶
        </button>
      </div>
      <div className="info">
        <h3>{mediaData.name}</h3>
        
        {/* 导演信息 */}
        {mediaData.director && mediaData.director !== '未知导演' && (
          <div className="director">
            导演: {mediaData.director}
          </div>
        )}
        
        {/* 类型信息 */}
        {mediaData.genres && (
          <div className="genres">
            {mediaData.genres}
          </div>
        )}
        
        {/* 评分和年份 */}
        <div className="meta-info">
          {mediaData.rating > 0 && (
            <span className="rating">⭐ {mediaData.rating}</span>
          )}
          {mediaData.year && (
            <span className="year">{mediaData.year}年</span>
          )}
        </div>
        
        {/* 播放量 - 最重要的显示 */}
        {mediaData.views && mediaData.views !== '-' && (
          <div className="views-info">
            👁️ {mediaData.views}次观看
          </div>
        )}
        
        {/* 简介 */}
        {mediaData.description && (
          <div className="description">
            {mediaData.description.length > 40 
              ? mediaData.description.substring(0, 40) + '...' 
              : mediaData.description}
          </div>
        )}
      </div>
    </div>
  );
}

export default memo(MediaCard);
